
// flightSlice.js
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { getFlightOneWayTwoTypeVender } from '../../services/flight/flightServices';

export const fetchOneWayFlightList = createAsyncThunk(
    'flight/oneway',
    async ({ reqBody }, { rejectWithValue }) => {
        try {
            // const response = await getFlightOneWayResultData(reqBody);
            const response = await getFlightOneWayTwoTypeVender(reqBody);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
);


const flightOneWaySlice = createSlice({
    name: 'flightOneWay',
    initialState: {
        oneWayFlightData: null,
        loading: false,
        error: null,
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchOneWayFlightList.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchOneWayFlightList.fulfilled, (state, action) => {
                state.oneWayFlightData = action.payload;
                state.loading = false;
            })
            .addCase(fetchOneWayFlightList.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    },
});

export default flightOneWaySlice.reducer;



